import { AsyncRequest } from 'angieslist-app-platform';

export default {
  ...AsyncRequest.createActionKeys('GET_USER'),
};



// WEBPACK FOOTER //
// ./src/app/common/user/userActionKeys.js